import { PersonAddOutlined, PersonRemoveOutlined } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { setFriends } from '../redux/appSlice'

const Friend = ({friendId,name,subTitle,userPicturePath,isProfile}) => {
    const {_id}=useSelector((state)=>state.app.user)
    const {token}=useSelector((state)=>state.app)
    const {friends}=useSelector((state)=>state.app.user)
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const params=useParams()

    const isFriend=friends.find((friend)=> friend._id===friendId )
    const updateFriend= async()=>{
      const response= await fetch(`https://thoughtful-erin-oyster.cyclic.app/users/${_id}/${friendId}`,{
            method:"PATCH",
            headers:{
                authorization:`Bearer ${token}`,
                'Content-Type':"application/json"
            },
        })
        const data= await response.json()
        dispatch(setFriends({friends:data}))
    }
  return (
    <div className='flex justify-between items-center w-full '>
            <div className='flex gap-2 cursor-pointer' onClick={()=>{
                navigate(`/profile/${friendId}`)
                // window.location.reload()
                }}>
                <div className="w-[35px] h-[35px]">
                    <img className='w-full h-full rounded-full object-cover' src={`${userPicturePath}`} alt="" /> 
                </div>
                <div className='flex flex-col'>
                    <h3 className='text-xs font-semibold text-gray-500 dark:text-gray-200 capitalize'>{name}</h3>
                    <h3 className='text-xs text-gray-400 capitalize'>{subTitle}</h3>
                </div>
            </div>
            <div onClick={()=>updateFriend()}>
            {params.userId?(
                params.userId===_id && friendId!==_id ?(
                    isFriend  ? 
                (
                <div className='rounded-full w-[1.8rem] h-[1.8rem] grid place-content-center  bg-rose-200 '>
                    <PersonRemoveOutlined className=" w-full svg-size text-rose-600 cursor-pointer" />
                </div>
                ) : 
                (
                    <div className='rounded-full w-[1.8rem] h-[1.8rem] grid place-content-center bg-rose-200'>
                    <PersonAddOutlined className="svg-size text-rose-600 cursor-pointer" />
                    </div>
                )
                ):(null)
            ):
            (
                friendId!==_id?(
                    isFriend  ? 
                (
                <div className='rounded-full w-[1.8rem] h-[1.8rem] grid place-content-center  bg-rose-200 '>
                    <PersonRemoveOutlined className=" w-full svg-size text-rose-600 cursor-pointer" />
                </div>
                ) : 
                (
                    <div className='rounded-full w-[1.8rem] h-[1.8rem] grid place-content-center bg-rose-200'>
                    <PersonAddOutlined className="svg-size text-rose-600 cursor-pointer" />
                    </div>
                )
                ):(null)
            )}
            </div>
        </div>
  )
}

export default Friend